import classNames from 'classnames'

import type { Image } from 'types'
import { BackgroundImage } from 'content-components/_Primatives/Images'
import { HeadlineTwo } from 'content-components/_Primatives/Headlines'
import Paragraph from 'content-components/_Primatives/Paragraph'
import style from './style.scss'

type Props = {
  bodyText: string
  className?: string
  headlineText: string
  image: Image
}

function PageNotFound(props: Props) {
  const { className, headlineText, bodyText, image } = props

  return (
    <BackgroundImage
      className={classNames(style.wrapper, className)}
      image={image}
    >
      <HeadlineTwo className={style.headline}>{headlineText}</HeadlineTwo>
      <Paragraph>{bodyText}</Paragraph>
    </BackgroundImage>
  )
}

export default PageNotFound
